export enum IncentiveRecordsManagerTypeEnum {
  LineManager = 'Line Manager',
  CompanyManager = 'In Company Manager'
}
